var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4925 19.5789C11.652 20.6917 12.6099 21.5479 13.7664 21.5479C14.9229 21.5479 15.8808 20.6914 16.0403 19.5789H18.3607C18.9295 19.5789 19.4575 19.2845 19.7564 18.8008C20.0554 18.3171 20.0826 17.7129 19.8283 17.2043C19.8283 17.2043 19.4283 16.4042 19.0699 15.6875C18.8195 15.1864 18.6889 14.6337 18.6889 14.0732V11.3747C18.6889 8.65613 16.4849 6.45215 13.7664 6.45215C11.0478 6.45215 8.84386 8.65613 8.84386 11.3747V14.0732C8.84386 14.6337 8.71325 15.1864 8.46286 15.6875C8.1045 16.4042 7.70446 17.2043 7.70446 17.2043C7.45013 17.7129 7.47737 18.3171 7.77633 18.8008C8.07529 19.2845 8.60332 19.5789 9.17203 19.5789H11.4925ZM15.3744 19.5789H12.1584C12.3106 20.3274 12.9732 20.8916 13.7664 20.8916C14.5596 20.8916 15.2221 20.3274 15.3744 19.5789ZM13.7664 7.10849C11.4101 7.10849 9.5002 9.01843 9.5002 11.3747V14.0732C9.5002 14.7354 9.34596 15.3888 9.04995 15.9812C8.69159 16.6979 8.29156 17.4976 8.29156 17.4976C8.13896 17.8028 8.15504 18.1655 8.33455 18.4556C8.51406 18.746 8.83074 18.9225 9.17203 18.9225H18.3607C18.702 18.9225 19.0187 18.746 19.1982 18.4556C19.3777 18.1655 19.3938 17.8028 19.2412 17.4976C19.2412 17.4976 18.8412 16.6979 18.4828 15.9812C18.1868 15.3888 18.0326 14.7354 18.0326 14.0732V11.3747C18.0326 9.01843 16.1226 7.10849 13.7664 7.10849Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.7280ab3dc7fd492e07a2fc7e0744cf3f.svg";
export { ForwardRef as ReactComponent };